import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer saldos iniciales de estaciones
export const getSaldoInicialEstaciones = async ({ estacion, desde, hasta } = {}) => {
  const token = localStorage.getItem("token") || "";
  const q = new URLSearchParams();

  if (estacion) q.set("estacion", estacion);
  if (desde) q.set("desde", desde);
  if (hasta) q.set("hasta", hasta);

  const url = `${BASE_URL}/saldoinicialestacion${q.toString() ? "?" + q.toString() : ""}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR GET /saldoinicialestacion:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al obtener saldo inicial de estación",
    };
  }
};

// ✅ GET: Traer saldo inicial de estación por ID
export const getSaldoInicialEstacionById = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/saldoinicialestacion/${id}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR GET /saldoinicialestacion/:id:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al obtener saldo inicial de estación",
    };
  }
};

// ✅ POST: Crear saldo inicial de estación
export const postSaldoInicialEstacion = async (payload) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/saldoinicialestacion`;

  try {
    const resp = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR POST /saldoinicialestacion:", error.response?.data);
    console.log("❌ STATUS:", error.response?.status);
    console.log("❌ MSG:", error.message);

    return {
      ok: false,
      error: error.response?.data || "Error al crear saldo inicial de estación",
    };
  }
};

// ✅ DELETE: Anular saldo inicial de estación
export const deleteSaldoInicialEstacion = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/saldoinicialestacion/${id}`;

  try {
    const resp = await axios.delete(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR DELETE /saldoinicialestacion:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar saldo inicial de estación",
    };
  }
};